import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

function readCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : '';
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAnonymous, setIsAnonymous] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Prefer SSO cookies; fall back to headers if host page set them earlier.
    const ssec = readCookie('ssec');
    const tksec = readCookie('tksec') || readCookie('tsec');
    if (ssec && tksec) {
      axios.defaults.headers.common.AuthorizationType = 'sso';
      axios.defaults.headers.common.ssec = ssec;
      axios.defaults.headers.common.tksec = tksec;
    }

    axios.get('/api/users/me')
      .then((response) => {
        const me = response.data;
        setUser({
          userId: me.id,
          username: me.username,
          isAnonymous: !!me.isAnonymous
        });
        setIsAnonymous(!!me.isAnonymous);
        setIsAuthenticated(!me.isAnonymous);
      })
      .catch(() => {
        setUser(null);
        setIsAuthenticated(false);
        setIsAnonymous(true);
      })
      .finally(() => setLoading(false));
  }, []);

  const refreshUser = async () => {
    const response = await axios.get('/api/users/me');
    const me = response.data;
    setUser({
      userId: me.id,
      username: me.username,
      isAnonymous: !!me.isAnonymous
    });
    setIsAnonymous(!!me.isAnonymous);
    setIsAuthenticated(!me.isAnonymous);
    return me;
  };

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, isAnonymous, loading, refreshUser }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
